import React, { useState, useCallback } from 'react';
import { Upload, Loader2 } from 'lucide-react';
import { Progress } from '@/components/ui/progress';

/**
 * Drag & Drop File Upload Komponente
 * Unterstützt Drag & Drop und Click-to-Upload
 */
const FileDropzone = ({ accept, onFileSelect, label, description, isLoading, loadingText, compact = false }) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files && files.length > 0) onFileSelect(files[0]);
  }, [onFileSelect]);

  const handleFileInput = (e) => {
    const file = e.target.files?.[0];
    if (file) onFileSelect(file);
  };

  return (
    <div
      onDragEnter={(e) => { e.preventDefault(); setIsDragging(true); }}
      onDragLeave={(e) => { e.preventDefault(); setIsDragging(false); }}
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
      className={`relative border-2 border-dashed rounded-xl text-center transition-all cursor-pointer ${
        compact ? "p-4" : "p-8"
      } ${isDragging ? "border-[#0F4C5C] bg-[#E8F1F2]" : "border-slate-300 hover:border-slate-400 hover:bg-slate-50"}`}
    >
      <input type="file" accept={accept} onChange={handleFileInput}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" disabled={isLoading} />

      {isLoading ? (
        <div className="flex flex-col items-center gap-2">
          <Loader2 className={`${compact ? "w-6 h-6" : "w-12 h-12"} text-[#0F4C5C] animate-spin`} />
          <div className="text-sm font-medium text-[#0F4C5C]">{loadingText || "Verarbeitung..."}</div>
          {!compact && <Progress value={33} className="w-48" />}
        </div>
      ) : (
        <div className="flex flex-col items-center gap-2">
          <Upload className={`${compact ? "w-6 h-6" : "w-12 h-12"} text-slate-400`} />
          <div className={`${compact ? "text-sm" : "text-lg"} font-medium text-slate-700`}>{label}</div>
          {!compact && <p className="text-sm text-slate-500">{description}</p>}
        </div>
      )}
    </div>
  );
};

export default FileDropzone;
